exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-main-content-tsx": () => import("./../../../src/pages/main-content.tsx" /* webpackChunkName: "component---src-pages-main-content-tsx" */),
  "component---src-pages-testimonial-form-tsx": () => import("./../../../src/pages/testimonial-form.tsx" /* webpackChunkName: "component---src-pages-testimonial-form-tsx" */)
}

